import {
  CourseDetailType,
  CourseHousingType,
  CourseType,
  ILanguageAutocompleteValue,
  IRequiredDoc,
} from "./types";
import { getAllLanguagesGroupedByPopularity } from "./helpers";
import { IAccordionItem } from "../../components/AccordionList";

const MOST_POPULAR: string[] = ["eng", "deu", "fra", "spa"];
//TODO: correct text
export const CATEGORIES: { [key: string]: string[] } = {};

export const LANGUAGES: ILanguageAutocompleteValue[] =
  getAllLanguagesGroupedByPopularity(MOST_POPULAR);

export const COURSE_TYPES = [
  {
    id: CourseType.ONLINE,
    name: "Online",
  },
  {
    id: CourseType.ON_CAMPUS,
    name: "On Campus",
  },
];

export const COURSE_TYPES_MAP = {
  [CourseType.ONLINE]: "Online",
  [CourseType.ON_CAMPUS]: "On Campus",
};

export const COURSE_REQUIRED_DOCS: IRequiredDoc[] = [
  {
    shortName: "Passport",
    longName: "Passport",
    name: "passport",
  },
  {
    shortName: "CV",
    longName: "CV",
    name: "cv",
  },
  {
    shortName: "Diploma",
    longName: "Diploma",
    name: "diploma",
  },
  {
    shortName: "Transcript",
    longName: "Transcript",
    name: "transcript",
  },
  {
    shortName: "Exam cert.",
    longName: "Exam Certificate",
    name: "exam_cert",
  },
  {
    shortName: "Lang. prof.",
    longName: "Language Proficiency",
    name: "language_proficiency",
  },
];

export const COURSE_HOUSING_TYPES = [
  {
    id: CourseHousingType.RESIDENCE,
    name: "Residence",
  },
  {
    id: CourseHousingType.HOMESTAY,
    name: "Homestay",
  },
  {
    id: CourseHousingType.NO_HOUSING,
    name: "No Housing",
  },
];

export const COURSE_HOUSING_TYPES_MAP = {
  [CourseHousingType.RESIDENCE]: "Residence",
  [CourseHousingType.HOMESTAY]: "Homestay",
  [CourseHousingType.NO_HOUSING]: "No Housing",
};

export const courseDetailsConfig: IAccordionItem[] = [
  {
    type: CourseDetailType.COURSE_DESCRIPTION,
    name: "Course Description",
    isRequired: false,
  },
  {
    type: CourseDetailType.AREAS_OF_CONCENTRATION,
    name: "Areas of Concentration",
    isRequired: false,
  },
  {
    type: CourseDetailType.START_DATES,
    name: "Start Dates",
    isRequired: false,
  },
  {
    type: CourseDetailType.PRICES,
    name: "Prices",
    isRequired: true,
  },
  {
    type: CourseDetailType.PAYMENT_PLAN_OPTIONS,
    name: "Payment Plan Options",
    isRequired: false,
  },
  {
    type: CourseDetailType.DISCOUNT,
    name: "Discount",
    isRequired: false,
  },
  {
    type: CourseDetailType.OTHER_FEES,
    name: "Other Fees",
    isRequired: false,
  },
  {
    type: CourseDetailType.REQUIRED_DOCUMENTS,
    name: "Required Documents",
    isRequired: true,
  },
  {
    type: CourseDetailType.DEPOSIT_AND_REFUND_POLICY,
    name: "Deposit and Refund Policy",
    isRequired: true,
  },
  {
    type: CourseDetailType.EXAMS,
    name: "Exams",
    isRequired: false,
  },
  {
    type: CourseDetailType.LOCATIONS,
    name: "Locations",
    isRequired: false,
  },
  {
    type: CourseDetailType.CANCELLATION_POLICY,
    name: "Cancellation Policy",
    isRequired: false,
  },
  {
    type: CourseDetailType.OTHER_COMMENTS,
    name: "Other Comments",
    isRequired: false,
  },
  {
    type: CourseDetailType.FAQ,
    name: "FAQ",
    isRequired: false,
  },
];
